export enum AppStage {
  Dev = "development",
  Local = "local",
  Qa = "qa",
  Sec = "sec",
  Uat = "uat",
  Prod = "production",
}

export enum ToggledFeature {
  DefaultLandingPage = "DefaultLandingPage",
  MyCalendar = "MyCalendar",
  GoogleAnalytics = "GoogleAnalytics",
  AccountFundAccess = "AccountFundAccess",
  ManageContacts = "ManageContacts",
  GroupEmail = "GroupEmail",
  MyProfile = "MyProfile",
  ExpandedWireInstructions = "ExpandedWireInstructions",
  BrightcoveVideo = "BrightcoveVideo",
  DatadogRum = "DatadogRum",
}

export type FeatureConfig = {
  [key in AppStage]: boolean;
};
